<template>
  <div class="p-0">
    <h3 v-translate:privacy_policy="lang" class="text-center primary-text">Privacy Policy</h3>
    <div id="policy" v-if="policy" class="pl-40 pr-40 pt-20">
      <div class="card-body p-0">
        <div v-translate:dynamic_string="{ key: `${studyId}_privacy_policy_html`, val: lang, html: policy }" v-html="policy" />
      </div>
    </div>
    <div v-else>
      <div class="card-body">
        <p class="mt-30" v-translate:loading="lang">Loading...</p>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import { Bitrise } from "@/components/services/participant-service";

export default {
  name: "privacy-policy",
  data() {
    return {
      policy: "",
      pid: "",
      globalElement: null
    };
  },
  mounted() {
    this.loadContent();
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    studyId() {
      return this.participant.studyId;
    },
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  methods: {
    loadContent() {
      nprogress.start();
      let bitrise = new Bitrise();
      let htmlDataObj = bitrise.getHtmlData("privacy_policy");
      if (htmlDataObj) {
        htmlDataObj
          .then(html => {
            nprogress.done();
            this.policy = html.body.innerHTML;
          })
          .catch(() => {
            nprogress.done();
          });
      }
    }
  }
};
</script>
